// External Libraries
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

// UI Components
import FormField from '../../components/ui/FormField';
import CheckboxField from '../../components/ui/CheckboxField';
import SubmitButton from '../../components/ui/SubmitButton';

// Redux Actions
import { addCountryFunc } from '../../../store/custom-actions/countries-actions/AddCountryFunc';
import { getCountriesFunc } from '../../../store/custom-actions/countries-actions/GetContriesSlicer';


function NewCountryForm({ show, onHide }) {
  const { t } = useTranslation();
  const { register, reset, formState: { errors }, handleSubmit } = useForm();
  const { loading: submitLoading } = useSelector(state => state.addCountrySlicer);
  const dispatch = useDispatch();

  const resetForm = () => {
    onHide();
    reset();
  };

  const onSubmit = async (data) => {
    console.log(data);

    const payload = {
      ...data,
    };
    const result = await dispatch(addCountryFunc({ data: payload }));

    if (addCountryFunc.fulfilled.match(result)) {
      dispatch(getCountriesFunc());
      resetForm();
    }
  };

  return (
    <>
      <Modal show={show} onHide={onHide}>
        <Modal.Header>
          <Modal.Title>{t('New Country')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            id="submit-form-add"
            onSubmit={handleSubmit(onSubmit)}
          >
            <FormField
              label="Country"
              name="name"
              register={register}
              required={true}
              errors={errors}
            />
            <FormField
              label="Code"
              name="code"
              register={register}
              required={true}
              errors={errors}
            />
            <CheckboxField
              name="active"
              label="Activity"
              register={register}
              errors={errors}
              defaultChecked={true}
            />
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            {t('Close')}
          </Button>
          <SubmitButton
            isLoading={submitLoading}
            form="submit-form-add"
          />
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default NewCountryForm;
